export default [

    {
        path: '',
        name: 'encartes',
        redirect: { name: 'encartes-home' },
    },

    {
        path: 'home',
        name: 'encartes-home',
        component: () => import('@/aplicacao/modulos/encartes/_Home'),
        meta: { autenticacao: true, permissao: 'ROLE_ENCARTE' },
    },

    {
        path: 'formulario/:id?',
        name: 'encartes-formulario',
        component: () => import('@/aplicacao/modulos/encartes/formulario/Formulario'),
        meta: { autenticacao: true, permissao: 'ROLE_ENCARTE_SOLICITAR' },
    },

    {
        path: 'formulario/:id/sucesso',
        name: 'encartes-sucesso',
        component: () => import('@/aplicacao/modulos/encartes/formulario/Sucesso'),
        meta: { autenticacao: true, permissao: 'ROLE_ENCARTE_SOLICITAR' },
    },

    {
        path: 'historico',
        name: 'encartes-historico',
        component: () => import('@/aplicacao/modulos/encartes/Historico'),
        meta: { autenticacao: true, permissao: 'ROLE_ENCARTE' },
    },

    {
        path: 'pendencias',
        name: 'encartes-pendencias',
        component: () => import('@/aplicacao/modulos/encartes/Pendencias'),
        meta: { autenticacao: true, permissao: 'ROLE_ENCARTE_PENDENCIAS' },
    },

    {
        path: 'rascunhos',
        name: 'encartes-rascunhos',
        component: () => import('@/aplicacao/modulos/encartes/Rascunhos'),
        meta: { autenticacao: true, permissao: 'ROLE_ENCARTE_SOLICITAR' },
    },

    {
        path: ':id',
        name: 'encartes-fluxo',
        component: () => import('@/aplicacao/modulos/encartes/fluxo/Fluxo'),
        meta: { autenticacao: true, permissao: 'ROLE_ENCARTE' },
    },

    {
        path: 'relatorios/geral',
        name: 'encartes-relatorios-geral',
        component: () => import('@/aplicacao/modulos/encartes/relatorios/Geral'),
        meta: { autenticacao: true, permissao: 'ROLE_ENCARTE_RELATORIO_GERAL' },
    },

    {
        path: 'relatorios/ranking-sku',
        name: 'encartes-relatorios-ranking-sku',
        component: () => import('@/aplicacao/modulos/encartes/relatorios/RankingSku'),
        meta: { autenticacao: true, permissao: 'ROLE_ENCARTE_RELATORIO_RANKING_SKU' },
    },

    {
        path: 'relatorios/veiculacao',
        name: 'encartes-relatorios-veiculacao',
        component: () => import('@/aplicacao/modulos/encartes/relatorios/Veiculacao'),
        meta: { autenticacao: true, permissao: 'ROLE_ENCARTE_RELATORIO_VEICULACAO' },
    },

]
